export default __webpack_public_path__ + "static/memorial-day-sale-mobile-e3c6deffc230e2fbbd01caf5ee1570ce.webp";